export class CheckoutResultPageGuidelines {
  countDownShow: boolean;
  returnButtonShow: boolean;
}
